module.exports = __webpack_public_path__ + "img/nature-56.9b2c6286.jpg";